import React from 'react';
import PropTypes from 'prop-types';
import Loading from '../../../components/--primitives/pr-loading';
import {
  Popup,
  PopupBody,
  PopupFooter,
} from '../../../components/--primitives/pr-popup';
import {
  strictValidObject,
  strictValidString,
} from '../../../utils/commonUtils';

function ResumeReaderMsg({ isOpen, message, type, fontSize, showFooter }) {
  return (
    <Popup isOpen={isOpen} action={type}>
      <Loading className="loading loading-resume-reader" type="inline" />
      <PopupBody>
        {strictValidString(message) && (
          <div
            className={`${fontSize} content`}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: message }}
          />
        )}
        {strictValidObject(message) && message}
      </PopupBody>
      {showFooter && <PopupFooter />}
    </Popup>
  );
}

ResumeReaderMsg.propTypes = {
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
  message: PropTypes.string,
  type: PropTypes.string,
  fontSize: PropTypes.string,
  showFooter: PropTypes.bool,
};

ResumeReaderMsg.defaultProps = {
  isOpen: false,
  toggle: undefined,
  message: null,
  type: 'success',
  fontSize: 'text',
  showFooter: false,
};

export default ResumeReaderMsg;
